import { Capacitor } from '@capacitor/core';
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { MouseEventHandler, useCallback } from 'react';

interface PropsWithOnClick<T> {
	// The React type for the onClick prop
	onClick?: MouseEventHandler<T>;
}

export const useHaptics = <T extends HTMLButtonElement | HTMLAnchorElement = HTMLButtonElement>({
	onClick,
}: PropsWithOnClick<T>) => {
	const newOnClick = useCallback(
		(event: React.MouseEvent<T>) => {
			if (onClick) {
				if (Capacitor.isNativePlatform()) Haptics.impact({ style: ImpactStyle.Light });
				onClick(event);
			}
		},
		[onClick]
	);

	return newOnClick;
};
